import { computed, onMounted } from "vue";
import { useConversationStore } from "../stores";
/**
 * Manages the conversation list.
 * The admin shell owns the tenant-scoped SSE lifecycle so notifications stay
 * reactive outside the message page.
 */
export function useConversations() {
    const store = useConversationStore();
    onMounted(async () => {
        await store.fetchConversations();
        store.connectSSE();
    });
    return {
        conversations: computed(() => store.sortedConversations),
        filters: computed(() => store.filters),
        isLoading: computed(() => store.isLoadingConversations),
        hasNewMessages: computed(() => store.hasNewMessages),
        setFilters: (f) => store.setFilters(f),
        fetchConversations: () => store.fetchConversations(),
    };
}
